import { useEffect, useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createAdminCompanySim, updateAdminCompanySim } from "../../slices/admin/thunk";

const AdminSimModal = ({ show, onCloseClick, data, selectedCompany }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isShowError, setShowError] = useState(false);
    const companies = useSelector(state => state.Admin.company);
    const isNew = data === null;

    const defaultSimData = {
        id: '',
        sim_card_number: '',
        phone_number: '',
        vendor_name: '',
        is_effective: true,
        created_at: Math.floor(Date.now() / 1000),
        updated_at: Math.floor(Date.now() / 1000),
        admin_company_id: ''
    };

    const [simData, setSimData] = useState(() => ({
        ...defaultSimData,
        ...(data ?? {})
    }));

    useEffect(() => {
        if (show) {
            if (isNew) {
                setSimData({
                    ...defaultSimData,
                    admin_company_id: companies.length > 0 ? companies[0].id : "",
                });
            } else {
                setSimData({
                    ...defaultSimData,
                    ...(data ?? {})
                });
            }
        }
        // eslint-disable-next-line
    }, [show, isNew, companies, data]);

    const closeModal = () => {
        setShowError(false);
        onCloseClick(simData);
    }

    // Safe input handler with fallbacks
    const handleChange = (field) => (e) => {
        let value = e.target.value || '';
        if (field === 'is_effective') {
            value = value === 'true';
        }

        setSimData(prev => ({
            ...prev,
            [field]: value
        }));

        console.log("handleChange", field, value);
    };

    return (
        <Modal isOpen={show} toggle={() => { closeModal(false) }} centered={true} size="lg">
            <div className="modal-header">
                <div className="modal-title">{isNew ? t('PageAdmin.Btn.CreateSim') : t('PageAdmin.Btn.ModifySim')}</div>
                <div className="d-flex flex-row modal-close-btn">
                    <Button type="button" className="btn-close btn-sm btn-light" onClick={() => { closeModal(false); }} ></Button>
                </div>
            </div>
            <ModalBody className="d-flex flex-column">
                <form>
                    {isNew ? null :
                        <div className="row">
                            <div className="col-md-3">
                                <label className="col-form-label" htmlFor="admin-sim-id">{t('PageAdmin.CompanySimTable.ID')}</label>
                            </div>
                            <div className="col-md-9">
                                <input type="text" className="form-control" id="admin-sim-id" value={simData.id} disabled />
                            </div>
                        </div>}
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-sim-company">{t('PageAdmin.CompanyTable.Name')}</label>
                        </div>
                        <div className="col-md-9">
                            <select
                                className="form-control"
                                id="admin-sim-company"
                                value={simData.admin_company_id}
                                onChange={handleChange("admin_company_id")}
                                disabled={!isNew}
                            >
                                {
                                    companies.map(company => (
                                        <option key={company.id} value={company.id}>{company.name}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-sim-status">{t('PageAdmin.CompanySimTable.Status')}</label>
                        </div>
                        <div className="col-md-9">
                            <select
                                className="form-control"
                                id="admin-sim-status"
                                value={simData.is_effective}
                                onChange={handleChange("is_effective")}
                            >
                                <option value={true}>{t('PageAdmin.SimCardStatus.Normal')}</option>
                                <option value={false}>{t('PageAdmin.SimCardStatus.Stopped')}</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-sim-sim-card-number">{t('PageAdmin.CompanySimTable.SimCardNumber')}</label>
                        </div>
                        <div className="col-md-9">
                            <input type="text" maxLength={30} className="form-control" id="admin-sim-name" value={simData.sim_card_number} onChange={handleChange("sim_card_number")} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-sim-phone-number">{t('PageAdmin.CompanySimTable.PhoneNumber')}</label>
                        </div>
                        <div className="col-md-9">
                            <input type="text" maxLength={10} className="form-control" id="admin-sim-phone-number" value={simData.phone_number} onChange={handleChange("phone_number")} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label className="col-form-label" htmlFor="admin-sim-vendor-name">{t('PageAdmin.CompanySimTable.VendorName')}</label>
                        </div>
                        <div className="col-md-9">
                            <input type="text" maxLength={50} className="form-control" id="admin-sim-vendor-name" value={simData.vendor_name} onChange={handleChange("vendor_name")} />
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-column align-items-center company-save-modal-btn-container">
                    {isShowError ? <div className="company-save-modal-error">{t('PageAdmin.SaveCompanyModal.SaveError')}</div> : null}
                    <div className="d-flex flex-row justify-content-center ">
                        <Button className="btn-sm report-save-modal-btn" color="primary" onClick={() => {
                            closeModal(false)
                        }}> {t('PageReport.SaveReportModal.BtnCancel')} </Button>
                        <Button className="btn-sm report-save-modal-btn" color="primary" onClick={async () => {
                            let result = false;
                            if (isNew) {
                                console.log(simData);
                                result = await dispatch(createAdminCompanySim(simData, selectedCompany));
                            }
                            else {
                                result = await dispatch(updateAdminCompanySim(simData));
                            }
                            if (result === true) {
                                setShowError(false);
                                closeModal(true);
                            } else {
                                setShowError(true);
                            }
                        }}> {t('PageReport.SaveReportModal.BtnSave')} </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default AdminSimModal;